/**
 * GlassCard — Aether Command aesthetic: flat dark surface with subtle border + top color stripe.
 * Used by the new Dashboard + Sales page redesign per user design prompts.
 *
 * Differences from GlowCard:
 *  - No colored blur halo (uses flat #111111 surface instead)
 *  - Optional top accent stripe in feature color
 *  - 1px outline border (#262626) — outline-variant on hover
 *  - Slight lift on hover (translateY -4px)
 */
import React from 'react';
import { cn } from '@/lib/utils';
import { getFeatureColor } from '@/lib/feature-colors';

export const GlassCard = React.forwardRef(function GlassCard(
    {
        feature,
        stripe = true,
        hoverable = true,
        className,
        children,
        onClick,
        'data-testid': testId,
        ...rest
    },
    ref,
) {
    const fc = feature ? getFeatureColor(feature) : null;
    return (
        <div
            ref={ref}
            data-testid={testId}
            onClick={onClick}
            className={cn(
                'glass-card overflow-hidden',
                hoverable && 'glass-card-hoverable',
                onClick && 'cursor-pointer',
                className,
            )}
            {...rest}
        >
            {stripe && fc && (
                <div className="glass-card-stripe" style={{ backgroundColor: fc.hex }} />
            )}
            {children}
        </div>
    );
});

export default GlassCard;
